import { UPDATE_BATCH_TYPE, UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER, UPDATE_FROM_ADJUSTER, UPDATE_TO_ADJUSTER } from "../action-types/adjusterActionType"


export const updateConversationViewerSelectedAdjuster = (data: any) => {
    return {
        type: UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER,
        payload: data
    }
}

export const updateFromAdjuster = (data: any) => {
    return {
        type: UPDATE_FROM_ADJUSTER,
        payload: data
    }
}

export const updateToAdjuster = (data: any) => {
    return {
        type: UPDATE_TO_ADJUSTER,
        payload: data
    }
}

export const updateBatchType = (data: any) => {
    return {
        type: UPDATE_BATCH_TYPE,
        payload: data
    }
}